import styled from "styled-components";

export const MissionListFooterContainer = styled.div`
  width: 100%;
  padding: 24px 32px;
  border-top: 1px solid #e9e9e9;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 24px;
  background: white;
  position: sticky;
  bottom: 0;
  z-index: 10;
`;

export const MissionListFooterButtonsContainer = styled.div`
  align-self: stretch;
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 16px;
`;

export const MissionListFooterSecondaryButton = styled.button`
  flex: 1 1 0;
  padding: 16px 24px;
  outline: 2px solid #d1d1d1;
  outline-offset: -2px;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 4px;
  background: transparent;
  border: none;
  cursor: pointer;
  transition: all 0.2s;
  font-family: "Readex Pro", sans-serif;
  font-size: 20px;
  font-weight: 400;
  line-height: 24px;
  color: #1b1b1b;

  &:hover {
    opacity: 0.8;
  }
`;

export const MissionListFooterPrimaryButton = styled.button`
  flex: 1 1 0;
  padding: 16px 24px;
  background: #3f7f7d;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 4px;
  border: none;
  cursor: pointer;
  transition: all 0.2s;
  font-family: "Readex Pro", sans-serif;
  font-size: 20px;
  font-weight: 400;
  line-height: 24px;
  color: white;

  &:hover {
    opacity: 0.9;
  }
`;

export const MissionListFooterCheckmarkIcon = styled.div`
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    width: 20px;
    height: 20px;
  }
`;
